class ToggleNav {

  constructor(){
		this.body    = document.querySelector('body');
		this.trigger = document.querySelectorAll('[data-trigger="toggle-nav"]');
		this.target  = document.querySelector('[data-target="toggle-nav"]');

		if(this.target){
			this._init();
		}
	}

	_init(){

		for (let element of this.trigger) {
			element.addEventListener('click', (event)=> this._toggleNav(event) );
			window.addEventListener('click', (event)=> this._closeNav() );
		}
	}

	_toggleNav(event){
		
		// Stop propagation of close primary nav event
		event.stopPropagation();

		this._toggleState(this.body, 'locked-for-header-primary', 'unlocked');
		this._toggleState(this.target, 'open', 'closed');

		for (let element of this.trigger) {
			this._toggleState(element, 'open', 'closed');
		}

		this._toggleKeyboardListener();
	}

	_toggleState(elem, one, two){
		const newState = elem.getAttribute('data-state') === one ? two : one;
  	elem.setAttribute('data-state', newState);
	}
	
	_closeNav(){
		const currentNavState = this.target.getAttribute('data-state');
		if(currentNavState === 'open'){

			this.body.removeAttribute('data-state');
			this.target.setAttribute('data-state', 'closed');
			
			for (let element of this.trigger) {
				element.setAttribute('data-state', 'closed');
			}

			document.removeEventListener('keydown', this.functionReference);
		}
	}

	_toggleKeyboardListener(){
		const isActive = (this.target.getAttribute('data-state') === 'open');
		
		if(isActive){
			this.functionReference = this._onKeyDown.bind(this);
			document.addEventListener('keydown', this.functionReference);
		} else {
			document.removeEventListener('keydown', this.functionReference);
		}
	}

	_onKeyDown(e){
		switch (e.keyCode) {
			case 27:
			this._closeNav();
			break;
			default:
			break;
		}
	}

}

export let toggleNav = new ToggleNav();
